import { render, staticRenderFns } from "./ExitBrandModal.vue?vue&type=template&id=4133afa0&scoped=true"
import script from "./ExitBrandModal.vue?vue&type=script&lang=ts"
export * from "./ExitBrandModal.vue?vue&type=script&lang=ts"
import style0 from "./ExitBrandModal.vue?vue&type=style&index=0&id=4133afa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4133afa0",
  null
  
)

export default component.exports